import PropTypes from "prop-types";

import Icon from "components/ShellV2/Icon";
import Card from "./Card";
import Sparkline from "./Sparkline";

const TINT_CLASS = {
  teal: "rec-tint-teal",
  amber: "rec-tint-amber",
  green: "rec-tint-green",
  info: "rec-tint-info",
};

export default function KpiTile({
  icon,
  tint,
  label,
  value,
  unit,
  delta,
  sparklineData,
  sparklineColor,
}) {
  const hasSpark = Array.isArray(sparklineData) && sparklineData.length > 1;
  return (
    <Card>
      <div className="flex items-start justify-between gap-[10px]">
        <div className="flex-1 min-w-0">
          <div className="rec-kpi-label">{label}</div>
          <div className="rec-kpi-value">
            {value}
            {unit && <small>{unit}</small>}
          </div>
        </div>
        <div className={`rec-kpi-ic ${TINT_CLASS[tint] || TINT_CLASS.teal}`}>
          {icon && <Icon name={icon} fill />}
        </div>
      </div>
      <div className="mt-[10px] min-h-[32px] flex items-end justify-between gap-[10px]">
        {delta != null ? (
          <div
            className="rec-kpi-delta"
            style={{ color: delta >= 0 ? "var(--success)" : "var(--danger)" }}
          >
            <Icon name={delta >= 0 ? "trending_up" : "trending_down"} />
            {`${delta >= 0 ? "+" : ""}${delta}%`}
          </div>
        ) : (
          <span />
        )}
        {hasSpark && (
          <Sparkline data={sparklineData} color={sparklineColor} width={108} height={32} />
        )}
      </div>
    </Card>
  );
}

KpiTile.propTypes = {
  icon: PropTypes.string,
  tint: PropTypes.oneOf(["teal", "amber", "green", "info"]),
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  unit: PropTypes.string,
  delta: PropTypes.number,
  sparklineData: PropTypes.arrayOf(PropTypes.number),
  sparklineColor: PropTypes.string,
};

KpiTile.defaultProps = {
  icon: null,
  tint: "teal",
  unit: null,
  delta: null,
  sparklineData: null,
  sparklineColor: "var(--accent)",
};
